import "./styles/custom.css";
import "./styles/form.scss";
import "./styles/common.scss";
import React from "react"
import ActivationContainer from "./layout/activationContainer";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App()
{
  return (
    <Router>
      <Routes>
        <Route path="/activation" element={<ActivationContainer />} />
      </Routes>
    </Router>
  );
}

export default App;